import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocHeartbeatsRoute } from '@jira/router-routes__eoc-heartbeats-routes/src/eocHeartbeatsRoute.tsx';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { resources as heartbeatsResources } from '@atlassian/eoc-heartbeats/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';
import { HeartbeatsComponent, LazyHeartbeats } from './ui/HeartbeatsComponent.tsx';

export const eocHeartbeatsRouteEntry: Route = createEntry(eocHeartbeatsRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: HeartbeatsComponent,
	layout: opsTeamLayout,

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	resources: [
		...getNavigationResources(),
		...heartbeatsResources(),
		...teamDashboardResources(),
		getConsolidationStateResource(),
	] as RouteResources,

	navigation: {
		menuId: MenuIdPeople,
		horizontal: AsyncHorizontalOperationsNav,
	},

	forPaint: [
		LazyHorizontalOperationsNav,
		LazyAtlassianNavigation,
		LazyHeartbeats,
		LazyTeamDashboardSidebar,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
